import { css } from "styled-components";
import { media, theme } from "../../theme";
import { hexToRgba } from "../../utils/hexToRGBA";
import { AuthoryColorSchemes } from "../ProfileHero/V3ProfileHero.types";
import { AuthoryColorSchemeProps, getFontColor } from "./FontSetUtilities";

export type SharedOutlineProps = AuthoryColorSchemeProps & {
    $useBorder?: boolean;
    $dashOnHover: boolean;
    $isActive?: boolean;
    $hasContent?: boolean;
};

export const SharedOutline = css<SharedOutlineProps>`
    outline: 1px dashed
        ${({ $colorVariant, $customBackgroundColor, theme, $dashOnHover }) => {
            if (!$dashOnHover) return "rgba(0,0,0,0)";
            if ($colorVariant === AuthoryColorSchemes.userTheme) {
                return hexToRgba(getFontColor($customBackgroundColor || theme.customization.backgroundColor, $colorVariant), 0.35);
            } else {
                return hexToRgba("#FFFFFF", 0.35);
            }
        }};
    border-radius: 8px;
`;

export const SharedBorder = css<SharedOutlineProps>`
    border: 1px dashed
        ${({ $colorVariant, $customBackgroundColor, theme, $dashOnHover }) => {
            if (!$dashOnHover) return "rgba(0,0,0,0)";
            if ($colorVariant === AuthoryColorSchemes.userTheme) {
                return hexToRgba(getFontColor($customBackgroundColor || theme.customization.backgroundColor, $colorVariant), 0.35);
            } else {
                return hexToRgba("#FFFFFF", 0.35);
            }
        }};
`;

export const SharedOutlineStyles = css<SharedOutlineProps>`
    ${({ $useBorder }) => ($useBorder ? SharedBorder : SharedOutline)}

    ${media.custom(theme.breakpoints.phone)} {
        outline: ${({ $isActive }) => ($isActive ? SharedOutline : "none")};
        border: ${({ $useBorder, $hasContent }) => (!$hasContent ? SharedBorder : $useBorder ? "1px solid rgba(0,0,0,0)" : "none")};
    }

    &:hover {
        ${({ $useBorder }) => ($useBorder ? SharedBorder : SharedOutline)}
    }
`;
